/**
 * Observes header-wrapper height and sets --header-wrapper-height CSS variable on body.
 * Recalculates automatically when header height changes (e.g. scroll state, responsive).
 */
(function () {
  function setHeaderWrapperHeight() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper || !document.body) return;

    const height = headerWrapper.offsetHeight;
    document.body.style.setProperty('--header-wrapper-height', `${height}px`);
  }

  function init() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    setHeaderWrapperHeight();

    const resizeObserver = new ResizeObserver(() => {
      setHeaderWrapperHeight();
    });

    resizeObserver.observe(headerWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
